/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LocationTransferItemsDialog extends _Ext.ItemEditorDialog<LocationTransferItemsRow> {
        protected getFormKey() { return LocationTransferItemsForm.formKey; }
        //protected getIdProperty() { return LocationTransferItemsRow.idProperty; }
        protected getLocalTextPrefix() { return LocationTransferItemsRow.localTextPrefix; }
        // protected getNameProperty() { return LocationTransferItemsRow.nameProperty; }
        //protected getService() { return LocationTransferItemsService.baseUrl; }

        public form = new LocationTransferItemsForm(this.idPrefix);

        constructor() {
            super();

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);

            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.UnitLabour);

            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;



            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });



            ////// **** On Wastage % Change Event **** 
            ////this.form.WstPer.changeSelect2(e => {
            ////    this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            ////});
            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value) {
                    q.hideField(this.form.KaratId)
                    q.hideField(this.form.Purity)
                }
                else {
                    q.showAndSetRequiredField(this.form.KaratId)
                    q.showAndSetRequiredField(this.form.Purity)
                    q.showAndSetRequiredField(this.form.MetalId)
                }

            })
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });

            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item 
            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {

                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }

                    rate += k.BomAmount;

                }
                this.form.NetWeight.value = Wt;
                this.form.OtherPieces.value = othrpcs;
                this.form.StonePieces.value = clrpcs;
                this.form.StoneWeight.value = gms;
                this.form.DiamondPieces.value = diapcs;
                this.form.DiamondWeight.value = cts;
                this.form.Weight.value = Wt + gms + (cts / 5);
                this.form.UnitRate.value = rate;
                this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
                if (!this.HasBom && this.entity.ItemTypeId == 101) {
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                    this.form.NetWeight.value = this.entity.NetWeight;
                    this.form.UnitRate.value = this.entity.UnitRate;
                    this.form.NetAmount.value = this.entity.UnitRate * this.entity.Weight;
                    this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;
                }
            });





            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });

            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 
            this.form.ProductCode.changeSelect2(e => {
                try {
                    let id;
                    OMS.ProductMasterService.CustomList({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                        response => {
                            id = response.Entities[0];
                        }, { async: false });
                    if (id.ProductId != null || id.ProductId > 0) {
                        Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                        this.form.ProductCode.value = "";
                        this.form.ProductCode.element.focus();
                        return;

                    }
                }
                catch (undefined) {

                }
            });

        }

        afterLoadEntity() {
            super.afterLoadEntity();
            Serenity.EditorUtils.setReadonly(this.form.ProductCode.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductName.element, true);
            Serenity.EditorUtils.setReadonly(this.form.HSN.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductCode.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductTypeId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.CategoryId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.SubCategoryId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.CollectionId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.BrandId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.SuperTypeId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductSizeId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.UnitLabour.element, true);
            Serenity.EditorUtils.setReadonly(this.form.Weight.element, true);
            Serenity.EditorUtils.setReadonly(this.form.NetWeight.element, true);
            Serenity.EditorUtils.setReadonly(this.form.StonePieces.element, true);
            Serenity.EditorUtils.setReadonly(this.form.StoneWeight.element, true);
            Serenity.EditorUtils.setReadonly(this.form.DiamondPieces.element, true);
            Serenity.EditorUtils.setReadonly(this.form.DiamondWeight.element, true);
            Serenity.EditorUtils.setReadonly(this.form.OtherPieces.element, true);
            Serenity.EditorUtils.setReadonly(this.form.OtherWeight.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductCode.element, true);


            this.form.BOMDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");

            this.dialogTitle = "View: " + this.form.ProductCode.value;
            if (this.entityId != undefined) {
                if (!this.form.HasBom.value) {
                    this.HasBom = false;
                    q.hideEditorCategory(this.form.BOMDetails);
                    q.hideField(this.form.BOMDetails);
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                }
            }
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            btns.splice(Q.indexOf(btns, x => x.cssClass == "undo-delete-button"), 1);
            btns.splice(Q.indexOf(btns, x => x.cssClass == "localization-button"), 1);
            btns.splice(Q.indexOf(btns, x => x.cssClass == "clone-button"), 1);

            return btns;
        }

    }
}